import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon, grey600 } from '@paypalcorp/pp-react';

function SocialShareTwitter({ url, handleSocialLinkClick, linkTitle }) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'twitter')}
      title={linkTitle}
      style={{ color: grey600 }}
      data-testid="social-share-twitter"
    >
      <Icon name="share-twitter" size="lg" />
    </Link>
  );
}

SocialShareTwitter.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
  linkTitle: PropTypes.string,
};

export default SocialShareTwitter;
